module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2yxxL"))).then(() => module.bundle.root('hEqeo'));